import React from 'react';

const Input = React.forwardRef(({ 
  label, 
  error, 
  className = '', 
  id,
  type = 'text',
  ...props 
}, ref) => {
  const inputId = id || props.name || Math.random().toString(36).substr(2, 9);

  // Permite sobreescribir el margen inferior por defecto (mb-2) pasando clases de margen en className
  const defaultMargin = className.includes('mb-') ? '' : 'mb-2';

  return (
    <div className={`${defaultMargin} ${className}`}>
      {label && (
        <label 
          htmlFor={inputId} 
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {label}
        </label>
      )}
      <div className="relative">
        <input
            ref={ref}
            id={inputId}
            type={type}
            className={`
            appearance-none block w-full px-3 py-2 border rounded-md shadow-sm placeholder-gray-400 
            focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-colors
            ${props.rightElement ? 'pr-10' : ''} 
            ${error ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500' : 'border-gray-300'}
            `}
            {...props}
        />
        {props.rightElement && (
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
            {props.rightElement}
            </div>
        )}
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
